import { z } from "zod";
import { MediaType } from "../../firestore/collections";
import { type FunctionObjectReturn } from "../utils";
import { MAX_LESSON_DURATION_MINUTES } from "../../../constants/contentDurations";
import { CLIENT_REQUEST_ID_PATTERN } from "../../../constants/gamification/sessionCompleteAttribution";

export const RecordSessionCompleteBodySchema = z.object({
  mediaType: z.enum(MediaType),
  mediaId: z.string().min(1),
  fileAsKebabCase: z.string().min(1).optional(),
  /** Actively listened minutes (while playback was running). */
  activelyPlayedMinutes: z.number().int().min(0).max(MAX_LESSON_DURATION_MINUTES),
  /**
   * Client-generated path-safe id. Used for idempotency + activityLog / sessionResults doc id.
   * Alphanumeric, hyphen, underscore only (no `/`, `.`, or other path separators).
   */
  clientRequestId: z.string().regex(CLIENT_REQUEST_ID_PATTERN),
  /**
   * Optional ISO-8601 completion instant for offline calendar attribution
   * (streak, daypart, week/month buckets). Points remain server-capped.
   * Server rejects ages > 30 days and clamps small future skew.
   */
  completedAt: z.string().datetime({ offset: true }).optional(),
});

export type RecordSessionCompleteBody = z.infer<typeof RecordSessionCompleteBodySchema>;

export type RecordSessionCompletePayload = {
  pointsEarned: number;
  leveledUp: boolean;
  newLevel: number;
  newStreak: number;
  idempotent: boolean;
};

export type RecordSessionCompleteResponse = FunctionObjectReturn<RecordSessionCompletePayload>;
